const PlatformIcon = ({ height = 24, width = 24, customClass = '' }) => (
  <svg width={width} height={height} class={customClass} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13 12.9999V20.9999H21V12.9999H13ZM3 20.9999H11V12.9999H3V20.9999ZM3 2.99994V10.9999H11V2.99994H3ZM16.66 1.68994L11 7.33994L16.66 12.9999L22.32 7.33994L16.66 1.68994Z' fill='currentColor' />
  </svg>
)

export default PlatformIcon
